import { render } from "./InfoBoxGrid.vue?vue&type=template&id=799f2084&scoped=true"
import script from "./InfoBoxGrid.vue?vue&type=script&lang=js"
export * from "./InfoBoxGrid.vue?vue&type=script&lang=js"

import "./InfoBoxGrid.vue?vue&type=style&index=0&id=799f2084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799f2084"]])

export default __exports__